import { v1 } from '@/api/client';
import { signalMetadataDtoSchema } from '@/feature/signals/api-schema';
import type { SignalMetadataDto } from './api.types';

export const fetchSignalMetadata = (equipmentId: string) =>
  v1.get<SignalMetadataDto[]>(`equipment/${equipmentId}/signal-metadata`, {
    schema: signalMetadataDtoSchema,
  });
